<template>
  <div class="container">
      <br>
    <div class="row">
        <div class="col-md-2"></div><!--empty-->
        <div class="col-md-8">
            <b-img src="https://store.therelated.com/media/catalog/product/cache/f03ba44c9885396c018440241b93a015/w/s/ws12-orange_main_2.jpg" class="img-fluid rounded" style= "width: 350px;" ></b-img>
            
        </div>
        <div class="col-md-2"></div><!--empty-->
    </div>
    <br>
   
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4"> <h1>Product Name</h1> </div>
        <div class="col-md-4"> <h1><b-badge variant="primary" >$ PRİCE</b-badge> </h1> </div>
        <div class="col-md-2"></div>
    </div>
    <br>
    <div class="row" >
    <div class="col-md-2"></div>
    <div class="col-md-8" ><p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima tempora, exercitationem consectetur atque maiores corrupti in illum esse eos deserunt cupiditate debitis laborum adipisci tenetur iste! Quo iure consequatur soluta.</p></div>
    <div class="col-md-2"></div>
    </div>

</div>
</template>

<script>
export default {

}
</script>

<style>

</style>